/*!
 * Created by netlogix GmbH & Co. KG.
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RemindersState } from '@reminders/store/reminders.state';

const selectRemindersState = createFeatureSelector<RemindersState>('reminders');

export const getMyReminders = createSelector(selectRemindersState, state => state.myReminders);
export const getReminderTimerIds = createSelector(selectRemindersState, state => state.reminderTimerIds);
export const getSuspendedReminderIds = createSelector(selectRemindersState, state => state.suspendedReminderIds);
